"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _navigation = require("../navigation");

var _useResponsiveQuery = require("@eig-builder/core-utils/hooks/useResponsiveQuery");

var FocusTabsNavigation = function FocusTabsNavigation(_ref) {
  var children = _ref.children;
  var isMobile = (0, _useResponsiveQuery.useIsMobile)();
  return /*#__PURE__*/_react["default"].createElement(_navigation.Navigation, null, /*#__PURE__*/_react["default"].createElement(_navigation.Navigation.DetailBar, null, /*#__PURE__*/_react["default"].createElement(_navigation.Navigation.LeftAlign, null, /*#__PURE__*/_react["default"].createElement(_navigation.Navigation.BackButton, {
    highlighted: true,
    paddingRight: "8px"
  }), /*#__PURE__*/_react["default"].createElement(_navigation.Navigation.BreadCrumbs, null), !isMobile ? /*#__PURE__*/_react["default"].createElement(_navigation.Navigation.Tabs, null) : /*#__PURE__*/_react["default"].createElement("div", null)), /*#__PURE__*/_react["default"].createElement(_navigation.Navigation.CenterAlign, null)), isMobile ? /*#__PURE__*/_react["default"].createElement(_navigation.Navigation.DetailBar, {
    second: true
  }, /*#__PURE__*/_react["default"].createElement(_navigation.Navigation.LeftAlign, null, /*#__PURE__*/_react["default"].createElement(_navigation.Navigation.Tabs, null))) : /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement(_navigation.PageContent, null, children));
};

FocusTabsNavigation.propTypes = {
  children: _propTypes["default"].element
};
var _default = FocusTabsNavigation;
exports["default"] = _default;